import { useHistory } from "react-router-dom";

import { SkillsManagementModalType } from "../../parts/modals/import/constants/skills_management_modal_type";
import {
  SkillsManagementModalData,
  useSkillsManagementContext
} from "../contexts/skills_management_context_provider";

type UseSkillManagementModalReturn = {
  modalData: SkillsManagementModalData;
  openModal: (mode: SkillsManagementModalType, data?: SkillsManagementModalData) => void;
  closeModal: () => void;
};

export const useSkillManagementModal = (): UseSkillManagementModalReturn => {
  const history = useHistory();
  const {
    modal: { data, setData }
  } = useSkillsManagementContext();

  const openModal = (mode: SkillsManagementModalType, data?: SkillsManagementModalData) => {
    history.push(`/admin/skills_management/${mode}`);
    setData(data || {});
  };

  const closeModal = () => {
    history.push(`/admin/skills_management`);
    setData({});
  };

  return { openModal, closeModal, modalData: data };
};
